import React, { useState } from "react";
import vars from "../../vars";

const AddStageForm = ({ stages, onClose, onSave }) => {
    const [title, setTitle] = useState("");
    const sortedStages = stages ? [...stages].sort((a, b) => a.position - b.position) : [];

    const [position, setPosition] = useState(sortedStages.length + 1);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const body = { title, position };

        try {
            const response = await fetch(`${vars.apiUrl}/stages`, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body)
            });
            const data = await response.json();
            if (response.ok && data.success) {
                onSave();
                onClose();
            } else {
                alert(data.message || "שגיאה בהוספת השלב");
            }
        } catch (err) {
            alert("שגיאה בשרת");
        }
    };

    return (
        <form onSubmit={handleSubmit} className="add-stage-form">
            <label>
                שם שלב:
                <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} required />
            </label>

            <label>
                מיקום:
                <select value={position} onChange={(e) => setPosition(Number(e.target.value))}>
                    {Array.from({ length: sortedStages.length + 1 }, (_, index) => {
                        const newPos = index + 1;
                        let optionText = `מיקום ${newPos}`;

                        if (newPos === 1) {
                            optionText += " (התחלה)";
                        } else if (newPos === sortedStages.length + 1) {
                            optionText += " (סוף)";
                        } else {
                            const nextStage = sortedStages.find(s => s.position === newPos);
                            if (nextStage) {
                                optionText += ` (לפני ${nextStage.title})`;
                            }
                        }

                        return (
                            <option key={newPos} value={newPos}>
                                {optionText}
                            </option>
                        );
                    })}
                </select>
            </label>

            <div className="popup-buttons">
                <button type="submit" className="save-btn">הוסף</button>
                <button type="button" className="cancel-btn" onClick={onClose}>ביטול</button>
            </div>
        </form>
    );
};

export default AddStageForm;